import ProgressBar from 'components/ProgressBar';
import { usePaymentSuccessContext } from 'pages/PaymentSuccess/context';

import { ITEMS } from './constants';

const ProgressSidebar: React.FunctionComponent = function () {
  const { isLoading } = usePaymentSuccessContext();
  return (
    <div className="flex flex-col p-4 w-[220px] xl:w-64">
      <div className="sticky top-[120px]">
        <ProgressBar items={ITEMS} lastPassed isLoading={isLoading} />
      </div>
    </div>
  );
};

export default ProgressSidebar;
